import "@mui/lab/themeAugmentation";
import { alpha, createTheme, darken, lighten } from "@mui/material";
import "@mui/material/styles";
import React from "react";

// declare module "@mui/material/styles" {
//   interface TypographyVariants {
//     subtitle1b: React.CSSProperties;
//     subtitle1: React.CSSProperties;
//     subtitle2: React.CSSProperties;
//     subtitle2b: React.CSSProperties;
//     subtitle3: React.CSSProperties;
//     subtitle3b: React.CSSProperties;
//     subtitle4: React.CSSProperties;
//     subtitle5: React.CSSProperties;
//     label: React.CSSProperties;
//     value: React.CSSProperties;
//   }
//   interface TypographyVariantsOptions {
//     subtitle1b?: React.CSSProperties;
//     subtitle1?: React.CSSProperties;
//     subtitle2?: React.CSSProperties;
//     subtitle2b?: React.CSSProperties;
//     subtitle3?: React.CSSProperties;
//     subtitle3b?: React.CSSProperties;
//     subtitle4?: React.CSSProperties;
//     subtitle5?: React.CSSProperties;
//     label?: React.CSSProperties;
//     value?: React.CSSProperties;
//   }

//   interface Theme {
//     sidebar: {
//       background: string;
//       textColor: string;
//       dividerBg: string;
//       menuItemColor: string;
//       menuItemColorActive: string;
//       menuItemBg: string;
//       menuItemBgActive: string;
//       menuItemBgHover: string;
//       menuItemIconColor: string;
//       menuItemIconColorActive: string;
//       menuItemHeadingColor: string;
//       menuItemBorderRadius: string;
//       boxShadow: string;
//       width: string;
//       fontFamily: string;
//       menuItemFontSize: string;
//       menuItemTextColor: string;
//       toggledWidth: string;
//       padding: string;
//     };
//     header: {
//       textColor: string;
//       height: string;
//       background: string;
//       boxShadow: string;
//       borderBottom: string;
//     };
//     invest: {
//       linearGradient: string;
//       linearGradientOnHover: string;
//     };
//     ar_invoice: {
//       virtual_id: {
//         primary: string;
//       };
//       template: {
//         template_one: {
//           primary: string;
//           memo: string;
//         };
//         template_two: {
//           primary: string;
//           memo: string;
//         };
//         template_three: {
//           primary: string;
//           memo: string;
//         };
//       };
//       linearGradientOnHover: string;
//     };
//     impersonation: {
//       height: string;
//       bg_color: string;
//     };
//     sandbox: {
//       color: string;
//       boxShadow: string;
//     };
//     tags_and_categories: {
//       purple: string;
//       purpleBorder: string;
//       white: string;
//       whiteBorder: string;
//       blue: string;
//       blueBorder: string;
//     };
//     alertDropdown: {
//       border: string;
//       eventLabel: string;
//     };
//   }
// }

// declare module "@mui/material/Typography" {
//   interface TypographyPropsVariantOverrides {
//     subtitle1b: true;
//     subtitle1: true;
//     subtitle2: true;
//     subtitle2b: true;
//     subtitle3: true;
//     subtitle3b: true;
//     subtitle4: true;
//     subtitle5: true;
//     label: true;
//     value: true;
//   }
// }

// declare module "@mui/material/styles" {
//   interface ButtonPropsVariantOverrides {
//     default: true;
//     outlined_dark: true;
//     outlined_white: true;
//   }
// }

// declare module "@mui/material/Chip" {
//   interface ChipPropsVariantOverrides {
//     default: true;
//     pending: true;
//   }
// }
// declare module "@mui/material/Button" {
//   interface ButtonPropsVariantOverrides {
//     default: true;
//     outlined_dark: true;
//     outlined_white: true;
//   }
// }

// declare module "@mui/lab" {
//   interface TimelineDotPropsVariantOverrides {
//     default: true;
//     success: true;
//     pending: true;
//     error: true;
//   }
// }
const colors = {
  gradients: {
    blue1: "linear-gradient(135deg, #6B73FF 0%, #000DFF 100%)",
    blue2: "linear-gradient(135deg, #ABDCFF 0%, #0396FF 100%)",
    blue3: "linear-gradient(127.55deg, #141E30 3.73%, #243B55 92.26%)",
    orange1: "linear-gradient(135deg, #FCCF31 0%, #F55555 100%)",
    orange2: "linear-gradient(135deg, #FFD3A5 0%, #FD6585 100%)",
    purple1: "linear-gradient(135deg, #43CBFF 0%, #9708CC 100%)",
    pink1: "linear-gradient(135deg, #F6CEEC 0%, #D939CD 100%)",
    pink2: "linear-gradient(135deg, #F761A1 0%, #8C1BAB 100%)",
    green1: "linear-gradient(135deg, #FFF720 0%, #3CD500 100%)",
    black1: "linear-gradient(100.66deg, #434343 6.56%, #000000 93.57%)",
  },
  shadows: {
    success:
      "0px 1px 4px rgba(68, 214, 0, 0.25), 0px 3px 12px 2px rgba(68, 214, 0, 0.35)",
    error:
      "0px 1px 4px rgba(255, 25, 67, 0.25), 0px 3px 12px 2px rgba(255, 25, 67, 0.35)",
    info: "0px 1px 4px rgba(51, 194, 255, 0.25), 0px 3px 12px 2px rgba(51, 194, 255, 0.35)",
    primary:
      "0px 1px 4px rgba(25, 117, 255, 0.25), 0px 3px 12px 2px rgba(25, 117, 255, 0.35)",
    warning:
      "0px 1px 4px rgba(255, 163, 25, 0.25), 0px 3px 12px 2px rgba(255, 163, 25, 0.35)",
    card: "0px 25px 19.4px -19px rgba(0, 0, 0, 0.07)",
    cardSm:
      "0px 2px 3px rgba(159, 162, 191, 0.18), 0px 1px 1px rgba(159, 162, 191, 0.32)",
    cardLg:
      "0 5rem 14rem 0 rgb(255 255 255 / 30%), 0 0.8rem 2.3rem rgb(0 0 0 / 60%), 0 0.2rem 0.3rem rgb(0 0 0 / 45%)",
    activeTab:
      "0px 0px 5px 0px rgba(0, 0, 0, 0.07), 0px 0px 24px 0px rgba(0, 72, 229, 0.10)",
  },
  layout: {
    header: {
      bg: "#FDFEFF",
    },
    general: {
      bodyBg: "#F6F8FB",
    },
  },
  alpha: {
    white: {
      5: alpha("#ffffff", 0.02),
      10: alpha("#ffffff", 0.1),
      30: alpha("#ffffff", 0.3),
      50: alpha("#ffffff", 0.5),
      70: alpha("#ffffff", 0.7),
      100: "#ffffff",
    },
    black: {
      5: alpha("#000000", 0.02),
      10: alpha("#000000", 0.1),
      30: alpha("#000000", 0.3),
      50: alpha("#000000", 0.5),
      70: alpha("#000000", 0.7),
      100: "#000000",
    },
    gray: {
      5: alpha("#414141", 0.02),
      10: alpha("#414141", 0.1),
      30: alpha("#414141", 0.3),
      50: alpha("#414141", 0.5),
      70: alpha("#414141", 0.7),
      100: "#414141",
    },
  },
  primary: {
    lighter: "#F1F2FD",
    light: "#F0EBFF",
    main: "#A770FF",
    dark: "#9353ff",
    darker: "#391C66",
  },
  secondary: {
    lighter: "#F1E7FF",
    light: "#CFB1FF",
    main: "#A871FF",
    dark: "#7F4FCC",
    darker: "#391C66",
  },
  tertiary: {
    lighter: "#F2FCFF",
    light: "#B9F2FF",
    main: "#80E8FF",
    dark: "#5CB8CC",
    darker: "#245A66",
  },
  success: {
    lighter: "#E8F5E9",
    light: "#C8E6C9",
    main: "#2E7D32",
    dark: "#1B5E20",
  },
  warning: {
    lighter: lighten("#CD0000", 0.85),
    light: "#FFF1F1",
    main: "#FC7E7E",
    dark: "#CD0000",
  },
  error: {
    lighten: "#ffffffb3",
    lighter: lighten("#D92D20", 0.85),
    light: lighten("#D92D20", 0.3),
    main: "#D92D20",
    dark: darken("#D92D20", 0.2),
  },
  info: {
    lighter: lighten("#33C2FF", 0.85),
    light: lighten("#33C2FF", 0.3),
    main: "#33C2FF",
    dark: darken("#33C2FF", 0.2),
  },
  pending: {
    light: "#FFFAF0",
    main: "#FFD88D",
    dark: "#C5A363",
  },
  neutral: {
    grey: "#555861",
    white: "#ffffff",
    black: "#000000",
    white_light: "#F3F8FF",
    orange: "#EF6C00",
  },
  tags_and_categories: {
    white: "#FAFAFA",
  },
};

export const LightBloomTheme = createTheme({
  // direction: i18n.dir(),
  // @ts-ignore
  colors: {
    gradients: {
      blue1: colors.gradients.blue1,
      blue2: colors.gradients.blue2,
      blue3: colors.gradients.blue3,
      orange1: colors.gradients.orange1,
      orange2: colors.gradients.orange2,
      purple1: colors.gradients.purple1,
      pink1: colors.gradients.pink1,
      pink2: colors.gradients.pink2,
      green1: colors.gradients.green1,
      black1: colors.gradients.black1,
    },
    shadows: {
      success: colors.shadows.success,
      error: colors.shadows.error,
      primary: colors.shadows.primary,
      warning: colors.shadows.warning,
    },
    alpha: {
      white: {
        5: alpha(colors.neutral.white, 0.02),
        10: alpha(colors.neutral.white, 0.1),
        30: alpha(colors.neutral.white, 0.3),
        50: alpha(colors.neutral.white, 0.5),
        70: alpha(colors.neutral.white, 0.7),
        100: colors.neutral.white,
        A100: colors.neutral.white_light,
      },
      black: {
        5: alpha(colors.neutral.black, 0.02),
        10: alpha(colors.neutral.black, 0.1),
        30: alpha(colors.neutral.black, 0.3),
        50: alpha(colors.neutral.black, 0.5),
        70: alpha(colors.neutral.black, 0.7),
        100: colors.neutral.black,
      },
    },
    secondary: {
      lighter: colors.secondary.lighter,
      light: colors.secondary.light,
      main: colors.secondary.main,
      dark: colors.secondary.dark,
      darker: colors.secondary.darker,
    },
    primary: {
      lighter: colors.primary.lighter,
      light: colors.primary.light,
      main: colors.primary.main,
      dark: colors.primary.dark,
      darker: colors.primary.darker,
    },
    tertiary: {
      lighter: colors.tertiary.lighter,
      light: colors.tertiary.light,
      main: colors.tertiary.main,
      dark: colors.tertiary.dark,
      darker: colors.tertiary.darker,
    },
    success: {
      light: colors.success.light,
      main: colors.success.main,
      dark: colors.success.dark,
    },
    warning: {
      light: colors.warning.light,
      main: colors.warning.main,
      dark: colors.warning.dark,
    },
    error: {
      light: colors.error.light,
      main: colors.error.main,
      dark: colors.error.dark,
    },
    info: {
      lighter: colors.info.lighter,
      light: colors.info.light,
      main: colors.info.main,
      dark: colors.info.dark,
    },
  },
  alertDropdown: {
    border: "#E0E2E7",
    eventLabel: "#1976d2",
  },
  general: {
    reactFrameworkColor: "#00D8FF",
    borderRadiusSm: "4px",
    borderRadius: "6px",
    borderRadiusLg: "10px",
    borderRadiusXl: "18px",
  },
  sidebar: {
    background: "#FFF",
    textColor: colors.primary.darker,
    dividerBg: "#00000014",
    menuItemColor: colors.neutral.grey,
    menuItemColorActive: colors.primary.darker,
    menuItemBg: "transparent",
    menuItemBgActive: colors.primary.lighter,
    menuItemBgHover: "#C9C9CA",
    menuItemIconColor: colors.neutral.grey,
    menuItemIconColorActive: colors.primary.darker,
    menuItemHeadingColor: colors.primary.darker,
    menuItemBorderRadius: "7px",
    padding: "8px 12px",
    boxShadow: "0px 8px 37.29999923706055px 0px #6262621C",
    width: "260px",
    fontFamily: "Inter",
    menuItemFontSize: "14px",
    menuItemTextColor: "#4F5563",
    toggledWidth: "93px",
  },
  invest: {
    linearGradient: "linear-gradient(180deg, #E6F1FF 0%, #CEE4FF 100%)",
    linearGradientOnHover:
      "linear-gradient(180deg,rgb(209, 222, 240) 0%, #CEE4FF 100%)",
  },
  impersonation: {
    height: "35px",
    bg_color: colors.neutral.orange,
  },
  sandbox: {
    color: colors.neutral.orange,
    boxShadow: "0px 0px 35px 0px rgba(239, 108, 0, 0.12) inset",
  },
  ar_invoice: {
    virtual_id: {
      primary: "#F7F8FB",
    },
    template: {
      template_one: {
        primary: "#F9FBFF",
        memo: "#FAFEFF",
      },
      template_two: {
        primary: "#F6F8FC",
        memo: "#FAFEFF",
      },
      template_three: {
        primary: "#010101",
        memo: "#FAFEFF",
      },
    },
    linearGradientOnHover:
      "linear-gradient(180deg,rgb(209, 222, 240) 0%, #CEE4FF 100%)",
  },
  transitions: {
    duration: {
      enteringScreen: 300,
      leavingScreen: 300,
    },
  },
  header: {
    height: "65px",
    background: colors.layout.header.bg,
    boxShadow: "0px 4px 6px rgba(235, 236, 242, .5), 0px 2px 2px #EBECF2",
    textColor: colors.neutral.grey,
    borderBottom: "1px solid rgba(128, 128, 128, 0.18)",
  },
  spacing: 8,
  palette: {
    common: {
      black: colors.alpha.black[100],
      white: colors.alpha.white[100],
    },
    mode: "light",
    primary: {
      lighter: colors.primary.lighter,
      light: colors.primary.light,
      main: colors.primary.main,
      dark: colors.primary.dark,
    },
    secondary: {
      light: colors.secondary.light,
      main: colors.secondary.main,
      dark: colors.secondary.dark,
    },

    tertiary: {
      lighter: colors.tertiary.lighter,
      light: colors.tertiary.light,
      main: colors.tertiary.main,
      dark: colors.tertiary.dark,
      darker: colors.tertiary.darker,
    },
    error: {
      lighter: colors.error.lighter,
      lighten: colors.error.lighten,
      light: colors.error.light,
      main: colors.error.main,
      dark: colors.error.dark,
      contrastText: colors.alpha.white[100],
    },
    success: {
      lighter: colors.success.lighter,
      light: colors.success.light,
      main: colors.success.main,
      dark: colors.success.dark,
      contrastText: colors.alpha.white[100],
    },
    info: {
      lighter: colors.info.lighter,
      light: colors.info.light,
      main: colors.info.main,
      dark: colors.info.dark,
      contrastText: colors.alpha.white[100],
    },
    pending: {
      lighter: lighten(colors.pending.light, 0.2),
      light: colors.pending.light,
      main: colors.pending.main,
      dark: colors.pending.dark,
    },
    default: {
      dark: "#212121",
      lighter: "#E8EAED",
      main: "#9e9e9e",
    },
    warning: {
      lighter: colors.warning.lighter,
      light: colors.warning.light,
      main: colors.warning.main,
      dark: colors.warning.dark,
      contrastText: colors.alpha.white[100],
    },
    grey: {
      50: "#FBFBFB",
      100: "#F7F8FB",
      200: "#E8EAED",
      300: "#DCE0E5",
      400: "#E0E0E0",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      750: "#4F5563",
      800: "#424242",
      900: "#212121",
      A100: "#d5d5d5",
      A200: "#aaaaaa",
      A400: "#303030",
      A700: "#616161",
    },
    blue: {
      200: "#D1D6FA",
      50: "#F1F3F7",
      100: "#E5EDFF",
    },
    text: {
      primary: colors.alpha.black[100],
      secondary: colors.alpha.black[70],
      disabled: colors.alpha.black[50],
    },
    background: {
      paper: colors.alpha.white[100],
      default: colors.layout.general.bodyBg,
    },
    action: {
      active: colors.alpha.black[100],
      hover: colors.primary.lighter,
      hoverOpacity: 0.1,
      selected: colors.alpha.black[10],
      selectedOpacity: 0.1,
      disabled: colors.alpha.black[50],
      disabledBackground: colors.alpha.black[5],
      disabledOpacity: 0.38,
      focus: colors.primary.light,
      focusOpacity: 0.05,
      activatedOpacity: 0.12,
    },
    tonalOffset: 0.5,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          // padding: "0 !important",
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(darken(colors.primary.main, 0.4), 0.2),

          "&.MuiBackdrop-invisible": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          background: "#FFF",
        },
        wave: {
          "&::after": {
            background:
              "linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, rgba(219, 219, 219, 0.60) 50%, rgba(255, 255, 255, 0.00) 88%), #FFF",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          textTransform: "none",
          marginLeft: 8,
          marginRight: 8,
          fontWeight: "bold",
          "&.Mui-error": {
            color: colors.warning.main,
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          transition:
            "height 0.3s ease, color 0.3s ease, background-color 0.3s ease",
        },
        "html, body, #root": {
          width: "100%",
          height: "100%",
        },
        "#nprogress .bar": {
          background: colors.primary.main,
        },
        "#nprogress .spinner-icon": {
          borderTopColor: colors.primary.main,
          borderLeftColor: colors.primary.main,
        },
        "#nprogress .peg": {
          boxShadow:
            "0 0 10px " +
            colors.primary.main +
            ", 0 0 5px" +
            colors.primary.main,
        },
        ":root": {
          "--swiper-theme-color": colors.primary.main,
        },
        code: {
          background: colors.info.lighter,
          color: colors.info.dark,
          borderRadius: 4,
          padding: 4,
        },
        "@keyframes ripple": {
          "0%": {
            transform: "scale(.8)",
            opacity: 1,
          },
          "100%": {
            transform: "scale(2.8)",
            opacity: 0,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        iconOutlined: {
          color: colors.alpha.black[50],
        },
        icon: {
          top: "calc(50% - 14px)",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          position: "relative",
          fontSize: 14,
          fontFamily: "Inter",
          fontWeight: 500,
          color: "#757575",
          "& .MuiFormLabel-asterisk": {
            color: "red",
          },
        },
        outlined: {
          "&.MuiInputLabel-outlined": {
            position: "relative",
            top: "22px",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.alpha.black[50],
          },
          "&.Mui-focused:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.primary.main,
          },
          "&.Mui-error": {
            color: colors.warning.main,
          },
          "& input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 100px white inset",
            WebkitTextFillColor: "black",
            transition: "background-color 5000s ease-in-out 0s",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": {
            fontSize: "16px",
            fontWeight: 400,
            minHeight: "24px",
            fontFamily: "Inter",
          },
          "& .MuiInputBase-input::placeholder": {
            fontSize: "16px",
            fontWeight: 400,
            letterSpacing: "-0.28px",
            color: colors.neutral.grey,
            fontFamily: "Inter",
          },
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        colorPrimary: {
          fontWeight: "bold",
          lineHeight: "40px",
          fontSize: 13,
          background: colors.alpha.black[5],
          color: colors.alpha.black[70],
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          boxShadow: "0px 25px 19.4px -19px rgba(0, 0, 0, 0.07)",
          background: "#fff",
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        action: {
          marginTop: -5,
          marginBottom: -5,
        },
        title: {
          fontSize: 15,
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          borderRadius: "50px",
        },
      },
    },
    MuiChip: {
      variants: [
        {
          props: { variant: "default" },
          style: {},
        },
        {
          props: { variant: "outlined" },
          style: {
            background: "#FFF3E0",
            color: "#000",
          },
        },
        {
          props: { variant: "pending" },
          style: {
            background: colors.pending.light,
            color: colors.pending.main,
          },
        },
      ],
      styleOverrides: {
        colorSecondary: {
          background: "#EEEEEE",
          color: colors.alpha.black[100],
        },
        deleteIcon: {
          color: colors.error.light,

          "&:hover": {
            color: colors.error.main,
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          background: "#F7F8FB",
          borderRadius: "16px",
          "&.Mui-expanded": {
            margin: 0,
          },
          "&::before": {
            display: "none",
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          fontSize: "12px",
          fontWeight: 600,
          "&.Mui-expanded": {
            minHeight: "35px",
          },
        },
        content: {
          margin: "8px 0", // Adjust spacing
          "&.Mui-expanded": {
            margin: "12px 0", // Adjust spacing when expanded
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          fontSize: 14,
          fontWeight: "bold",
        },
        colorDefault: {
          background: colors.alpha.black[30],
          color: colors.alpha.white[100],
        },
      },
    },
    MuiAvatarGroup: {
      styleOverrides: {
        root: {
          alignItems: "center",
        },
        avatar: {
          background: colors.alpha.black[10],
          fontSize: 13,
          color: colors.alpha.black[70],
          fontWeight: "bold",

          "&:first-of-type": {
            border: 0,
            background: "transparent",
          },
        },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        alignItemsFlexStart: {
          marginTop: 0,
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        page: {
          fontSize: 13,
          fontWeight: "bold",
          transition: "all .2s",
          "&.Mui-selected": {
            background: colors.primary.light,
          },
          border: "none",
        },
        textPrimary: {
          "&.Mui-selected": {
            boxShadow: colors.shadows.primary,
          },
          "&.MuiButtonBase-root:hover": {
            background: colors.alpha.black[5],
          },
          "&.Mui-selected.MuiButtonBase-root:hover": {
            background: colors.primary.main,
          },
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "default" },
          style: {
            background: colors.primary.light,
            borderRadius: "8px",
            color: "#072778",
            fontWeight: 400,
            ":hover": {
              background: "none",
              border: "2px solid #EBF1FF",
            },
          },
        },
        {
          props: { variant: "outlined_dark" },
          style: {
            background: "transparent",
            borderRadius: "8px",
            border: "1px solid #E0E0E0",
            color: "#000",
            fontWeight: 500,
            padding: "8px 12px",
            ":hover": {
              background: "none",
              border: "1px solid #000",
            },
            "& .MuiButton-startIcon": {
              color: "#000",
            },
          },
        },
        {
          props: { variant: "outlined_white" },
          style: {
            background: "white",
            borderRadius: "8px",
            border: `1px solid ${colors.primary.lighter}`,
            color: colors.primary.main,
            fontWeight: 500,
            padding: "8px 12px",
            ":hover": {
              background: "white",
              border: `1px solid ${colors.primary.lighter}`,
            },
          },
        },
      ],
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          padding: "8px 12px",
          height: "35px",
          borderRadius: "8px",
          ".MuiSvgIcon-root": {
            transition: "all .2s",
          },
          fontSize: 12,
          fontWeight: 500,
        },
        endIcon: {
          marginRight: -8,
        },
        containedSecondary: {
          backgroundColor: colors.secondary.main,
          color: colors.alpha.white[100],
          border: "1px solid " + colors.alpha.black[30],
        },
        outlinedSecondary: {
          backgroundColor: colors.alpha.white[100],

          "&:hover, &.MuiSelected": {
            backgroundColor: colors.alpha.black[5],
            color: colors.alpha.black[100],
          },
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          height: "46px",
          fontFamily: "Inter",
          fontSize: "16px",
          fontWeight: 500,
          whiteSpace: "nowrap",
          borderRadius: "8px",
          "&.Mui-disabled": {
            background: "rgba(0, 0, 0, 0.08)",
            color: "rgba(0, 0, 0, 0.20)",
          },
        },
      },
    },
    MuiToggleButton: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          color: colors.primary.main,
          background: colors.alpha.white[100],
          transition: "all .2s",

          "&:hover, &.Mui-selected, &.Mui-selected:hover": {
            color: colors.alpha.white[100],
            background: colors.primary.main,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          ":hover": {
            background: colors.primary.lighter,
          },
          "& .MuiTouchRipple-root": {
            borderRadius: 6,
          },
        },
        sizeSmall: {
          padding: 4,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          margin: 0,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          "&:first-child": {
            paddingTop: 0,
          },
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          background: "#8080801a",
          border: 0,
          height: 1,
        },
        vertical: {
          height: "auto",
          width: 1,

          "&.MuiDivider-flexItem.MuiDivider-fullWidth": {
            height: "auto",
          },
          "&.MuiDivider-absolute.MuiDivider-fullWidth": {
            height: "100%",
          },
        },
        withChildren: {
          "&:before, &:after": {
            border: 0,
          },
        },
        wrapper: {
          background: colors.alpha.white[100],
          fontWeight: "bold",
          height: 24,
          lineHeight: "24px",
          marginTop: -12,
          color: "inherit",
          textTransform: "uppercase",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation0: {
          boxShadow: "none",
        },
        elevation: {
          boxShadow: colors.shadows.card,
        },
        elevation2: {
          boxShadow: colors.shadows.cardSm,
        },
        elevation24: {
          boxShadow: colors.shadows.cardLg,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          height: 6,
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          "& .MuiSlider-valueLabelCircle, .MuiSlider-valueLabelLabel": {
            transform: "none",
          },
          "& .MuiSlider-valueLabelCircle": {
            borderRadius: 6,
            width: 54,
          },
          "& .MuiSlider-valueLabel": {
            left: "calc(-50% - 14px)",
            color: colors.alpha.black[100],
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,

          "& .MuiListItem-button": {
            transition: "all .2s",

            "& > .MuiSvgIcon-root": {
              minWidth: 34,
            },

            "& .MuiTouchRipple-root": {
              opacity: 0.2,
            },
          },
          "& .MuiListItem-root.MuiButtonBase-root.Mui-selected": {
            backgroundColor: colors.alpha.black[10],
          },
        },
        padding: {
          padding: "12px",

          "& .MuiListItem-button": {
            borderRadius: 6,
            margin: "1px 0",
          },
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: "12px",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          height: "auto",
          minHeight: 40,
          padding: "4px",
          background: "#F7F8FB",
          borderRadius: "8px",
          scrollbarWidth: "none",
        },
        indicator: {
          height: 38,
          minHeight: 38,
          borderRadius: 6,
          background: "transparent",
        },
        scrollableX: {},
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          padding: 0,
          height: 38,
          minHeight: 38,
          borderRadius: "4px",
          transition: "color .2s",
          textTransform: "capitalize",
          fontWeight: 400,
          fontSize: "16px",

          "&.MuiButtonBase-root": {
            minWidth: "auto",
            paddingLeft: 20,
            paddingRight: 20,
            marginRight: 4,
          },
          "&.Mui-selected, &.Mui-selected:hover": {
            color: "#000",
            fontSize: "16px",
            fontWeight: 600,
            zIndex: 5,
            background: "#fff",
            boxShadow:
              "0px 0px 5px 0px rgba(0, 0, 0, 0.07), 0px 0px 24px 0px rgba(0, 72, 229, 0.10)",
          },
          "&:hover": {
            color: colors.alpha.black[100],
          },
          "&.Mui-disabled": {
            backgroundColor: "transparent",
            color: colors.neutral.grey[5],
            pointerEvents: "none",
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          // background:
          //   "linear-gradient(180deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.70) 100%)",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          // padding: 12,
        },
        list: {
          padding: 2,

          "& .MuiListItem-button": {
            fontSize: 14,
            transition: "all .2s",
            color: colors.alpha.black[70],

            "&:hover, &:active, &.active, &.Mui-selected": {
              color: colors.alpha.black[100],
              background: lighten(colors.primary.lighter, 0.5),
              borderRadius: "none",
            },
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          color: colors.secondary.main,
          "&:hover, &:active, &.Mui-selected": {
            color: colors.alpha.black[100],
            background: lighten(colors.primary.lighter, 0.5),
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        tag: {
          margin: 1,
        },
        root: {
          ".MuiAutocomplete-inputRoot.MuiOutlinedInput-root .MuiAutocomplete-endAdornment":
            {
              right: 14,
            },
        },
        paper: {
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.3)",
          zIndex: 100,
        },
        clearIndicator: {
          color: colors.error.main,
          marginRight: 8,

          "&:hover": {
            background: colors.neutral.white,
            color: colors.error.dark,
          },
        },
        popupIndicator: {
          color: "#9DA6CB",

          "&:hover": {
            background: colors.primary.lighter,
            color: colors.primary.main,
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          "& .MuiPaper-root": {
            width: "250px",
            boxShadow: "0px 2.81px 23.882px 0px rgba(0, 0, 0, 0.15)",
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          "& .MuiIconButton-root": {
            padding: 8,
          },
        },
        select: {
          "&:focus": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: "0 !important",
          padding: "0 !important",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        head: {
          background: "#F1F3F7",
        },
        root: {
          transition: "background-color .2s",

          "&.MuiTableRow-hover:hover": {
            backgroundColor: colors.primary.light,
            cursor: "pointer",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomColor: colors.alpha.black[10],
          fontSize: 12,
          color: colors.neutral.grey,
          padding: "12px 20px",
        },
        head: {
          textTransform: "capitalize",
          fontSize: 12,
          fontWeight: 600,
          color: colors.neutral.grey,
          backgroundColor: "#F1F3F7",
          padding: "12px 20px",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        message: {
          lineHeight: 1.5,
          fontSize: 12,
          fontFamily: "Inter",
          fontWeight: 400,
          width: "100%",
        },
        standardInfo: {
          borderColor: "#F1F2FD",
          color: "#000",
          backgroundColor: "#F1F2FD",
        },
        action: {
          color: "rgba(0, 0, 0, 0.7)", // Adjusted from colors.alpha.black[70]
        },
      },
    },
    MuiTimeline: {
      styleOverrides: {
        root: {
          padding: 0,
          margin: 0,
        },
        positionLeft: {
          padding: 0,
          margin: 0,
        },
      },
    },
    MuiTimelineDot: {
      variants: [
        {
          props: { variant: "default" },
          style: {},
        },
        {
          props: { variant: "success" },
          style: {
            background: colors.success.main,
            border: "none",
            left: "-4px",
          },
        },
        {
          props: { variant: "pending" },
          style: {
            background: colors.pending.main,
            border: "none",
            left: "-4px",
          },
        },
        {
          props: { variant: "error" },
          style: {
            background: colors.error.main,
            border: "none",
            left: "-4px",
          },
        },
      ],
      styleOverrides: {
        root: {
          margin: 0,
          zIndex: 5,
          position: "absolute",
          top: "50%",
          marginTop: -6,
          left: -6,
          height: "8px",
          width: "8px",
        },
        outlined: {
          backgroundColor: "transparent",
          borderColor: "#000",
          boxShadow: "inset 0px 0px 0px 1px #000",
        },
        outlinedPrimary: {
          backgroundColor: colors.alpha.white[100],
          boxShadow: "0 0 0 6px " + colors.alpha.white[100],
        },
      },
    },
    MuiTimelineConnector: {
      styleOverrides: {
        root: {
          position: "absolute",
          height: "100%",
          width: "2px",
          top: 0,
          borderRadius: 50,
          backgroundColor: colors.alpha.black[100],
        },
      },
    },
    MuiTimelineItem: {
      styleOverrides: {
        root: {
          minHeight: 0,
          padding: "8px 0",
        },
        missingOppositeContent: {
          "&:before": {
            display: "none",
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: alpha(colors.alpha.black["100"], 0.95),
          padding: "8px 16px",
          fontSize: 13,
          maxWidth: "500px",
          wordBreak: "break-word",
        },
        arrow: {
          color: alpha(colors.alpha.black["100"], 0.95),
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          width: ownerState.size === "medium" ? 40 : 32, // Default to small
          height: ownerState.size === "medium" ? 23.5 : 18,
          padding: 0,
          "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: ownerState.size === "medium" ? 2.9 : 2.1,
            height: "auto",
            transitionDuration: "300ms",
            background: "#fff",
            "&.Mui-checked": {
              transform:
                ownerState.size === "medium"
                  ? "translateX(17px)"
                  : "translateX(14px)",
              "& + .MuiSwitch-track": {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
                border: 0,
              },
              "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
              },
              "& .MuiSwitch-thumb": {
                backgroundColor: "#fff !important",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundImage:
                  ownerState.size === "medium" &&
                  `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 8 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.92183 0.23772C7.16848 -0.00892758 7.56837 -0.00892706 7.81502 0.237719C8.06166 0.484366 8.06166 0.88426 7.81502 1.13091L3.18344 5.76249C2.93679 6.00913 2.5369 6.00913 2.29025 5.76249L0.184985 3.65722C-0.0616618 3.41058 -0.0616617 3.01068 0.184985 2.76404C0.431632 2.51739 0.831526 2.51739 1.07817 2.76404L2.73684 4.42271L6.92183 0.23772Z" fill="black"/></svg>'); !important`,
              },
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
              color: "#F3F5F6",
            },
            "&.Mui-disabled + .MuiSwitch-track": {
              opacity: 0.7,
            },
          },
          "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: ownerState.size === "medium" ? 18 : 14,
            height: ownerState.size === "medium" ? 18 : 14,
            "&::hover": {
              background: "none !important",
            },
          },
          "& .MuiSwitch-track": {
            borderRadius: ownerState.size === "medium" ? 14 : 9, // Adjust based on size
            backgroundColor: "rgb(128 128 128 / 34%)",
            opacity: 1,
            "&:before, &:after": {
              content: '""',
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              width: ownerState.size === "medium" ? 24 : 16,
              height: ownerState.size === "medium" ? 24 : 16,
            },
          },
        }),
      },
    },

    MuiStepper: {
      styleOverrides: {
        root: {
          paddingTop: 20,
          paddingBottom: 20,
          background: colors.alpha.black[5],
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          "&.MuiStepIcon-completed": {
            color: colors.success.main,
          },
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: "h1",
          h2: "h2",
          h3: "div",
          h4: "div",
          h5: "div",
          h6: "div",
          subtitle1: "div",
          subtitle1b: "div",
          subtitle2: "div",
          subtitle2b: "div",
          subtitle3: "div",
          subtitle3b: "div",
          label: "div",
          value: "div",
          body1: "div",
          body2: "div",
        },
      },
      styleOverrides: {
        gutterBottom: {
          marginBottom: 4,
        },
        paragraph: {
          fontSize: 17,
          lineHeight: 1.7,
        },
      },
    },
  },
  shape: {
    borderRadius: 6,
  },
  typography: {
    fontFamily: [
      // "Plus Jakarta Sans",
      "Inter",
      "Poppins",
      '"Roboto"',
      '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    ].join(","),
    fontSize: 14,
    htmlFontSize: 15,
    h1: {
      fontWeight: 700,
      fontSize: 30,
      color: colors.alpha.black[100],
    },
    h2: {
      fontWeight: 700,
      fontSize: 22,
      color: colors.alpha.gray[100],
    },
    h3: {
      fontWeight: 600,
      fontSize: 18,
      lineHeight: 1.4,
      color: colors.alpha.gray[100],
    },
    h4: {
      fontWeight: 600,
      fontSize: 16,
      color: colors.alpha.gray[100],
    },
    h5: {
      fontWeight: 600,
      fontSize: 14,
      color: colors.alpha.gray[100],
    },
    h6: {
      fontSize: 12,
      color: colors.alpha.gray[100],
    },
    body1: {
      fontSize: 14,
    },
    body2: {
      fontSize: 12,
    },
    button: {
      fontSize: 14,
      fontWeight: 700,
    },
    caption: {
      fontSize: 13,
      fontWeight: 500,
      color: colors.alpha.black[50],
    },
    subtitle1: {
      fontSize: 14,
      fontFamily: "Inter",
      color: colors.neutral.grey,
      fontWeight: 400,
    },
    subtitle1b: {
      fontSize: 14,
      fontFamily: "Inter",
      color: colors.alpha.gray[100],
      fontWeight: 600,
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: 12,
      fontFamily: "Inter",
      color: colors.alpha.gray[100],
    },
    subtitle2b: {
      fontWeight: 600,
      fontSize: 12,
      fontFamily: "Inter",
      color: colors.alpha.gray[100],
    },
    subtitle3: {
      fontWeight: 400,
      fontFamily: "Inter",
      fontSize: 12,
      color: colors.alpha.gray[100],
    },
    subtitle4: {
      fontWeight: 400,
      fontFamily: "Inter",
      fontSize: "10px",
      color: colors.alpha.gray[100],
    },
    subtitle5: {
      fontWeight: 400,
      fontFamily: "Inter",
      fontSize: "8px",
      color: colors.alpha.gray[100],
    },
    label: {
      color: colors.alpha.gray[100],
      fontSize: 12,
      fontFamily: "Inter",
      fontWeight: 600,
    },
    value: {
      color: colors.alpha.gray[100],
      fontSize: 12,
      fontFamily: "Inter",
      fontWeight: 500,
    },
    overline: {
      fontSize: 13,
      fontWeight: 700,
      textTransform: "uppercase",
    },
  },
  shadows: [
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
  ],
  tags_and_categories: colors.tags_and_categories,
});
